$(window).on('load', function() {

  var lat, lng, loc, city, state, cityState, geocoder;

  var locationValue = $("#location").val();

  if($(window).width() > 700) {
    var defaultCenter = $('#center').val();
    defaultCenter = defaultCenter.split(',');

    var defaultCenterLat = parseFloat(defaultCenter[0]),
        defaultCenterLng = parseFloat(defaultCenter[1]),
        defaultZoom = parseFloat($('#zoom').val());

    var map = new Maplace({ 
      controls_on_map: false,
      map_options: {
        zoom: defaultZoom,
        set_center: [defaultCenterLat,defaultCenterLng]
      },
      afterCloseInfowindow: function(){
        map.Load();
      },
      styles: {
        'Noble':   
          [
            {"featureType": "administrative","elementType": "all","stylers": [{"visibility": "off"}]},
            {"featureType": "administrative","elementType": "geometry.stroke","stylers": [{"visibility": "on"}]},
            {"featureType": "administrative","elementType": "labels","stylers": [{"visibility": "on"},{"color": "#716464"},{"weight": "0.01"}]},
            {"featureType": "administrative.country","elementType": "labels","stylers": [{"visibility": "on"}]},
            {"featureType": "landscape","elementType": "all","stylers": [{"visibility": "simplified"}]},
            {"featureType": "landscape.natural","elementType": "geometry","stylers": [{"visibility": "simplified"}]},
            {"featureType": "landscape.natural.landcover","elementType": "geometry","stylers": [{"visibility": "simplified"}]},
            {"featureType": "poi","elementType": "all","stylers": [{"visibility": "simplified"}]},
            {"featureType": "poi","elementType": "geometry.fill","stylers": [{"visibility": "simplified"}]},
            {"featureType": "poi","elementType": "geometry.stroke","stylers": [{"visibility": "simplified"}]},
            {"featureType": "poi","elementType": "labels.text","stylers": [{"visibility": "simplified"}]},
            {"featureType": "poi","elementType": "labels.text.fill","stylers": [{"visibility": "simplified"}]},
            {"featureType": "poi","elementType": "labels.text.stroke","stylers": [{"visibility": "simplified"}]},
            {"featureType": "poi.attraction","elementType": "geometry","stylers": [{"visibility": "on"}]},
            {"featureType": "road","elementType": "all","stylers": [{"visibility": "on"}]},
            {"featureType": "road.highway","elementType": "all","stylers": [{"visibility": "off"}]},
            {"featureType": "road.highway","elementType": "geometry","stylers": [{"visibility": "on"}]},
            {"featureType": "road.highway","elementType": "geometry.fill","stylers": [{"visibility": "on"}]},
            {"featureType": "road.highway","elementType": "geometry.stroke","stylers": [{"visibility": "simplified"},{"color": "#a05519"},{"saturation": "-13"}]},
            {"featureType": "road.local","elementType": "all","stylers": [{"visibility": "on"}]},
            {"featureType": "transit","elementType": "all","stylers": [{"visibility": "simplified"}]},
            {"featureType": "transit","elementType": "geometry","stylers": [{"visibility": "simplified"}]},
            {"featureType": "transit.station","elementType": "geometry","stylers": [{"visibility": "on"}]},
            {"featureType": "water","elementType": "all","stylers": [{"visibility": "simplified"},{"color": "#84afa3"},{"lightness": 52}]},
            {"featureType": "water","elementType": "geometry","stylers": [{"visibility": "on"}]},
            {"featureType": "water","elementType": "geometry.fill","stylers": [{"visibility": "on"}]}
          ]
      }
    }).Load();

    $(window).resize(function(){		
      map.Load();
    });	

  }

  var geocoder = new google.maps.Geocoder();

  if (!navigator.geolocation){
    //console.log('not geolocating')
  } else {
    navigator.geolocation.getCurrentPosition(function(position) {
      lat = position.coords.latitude;
      lng = position.coords.longitude;
      loadCityStateFromLatLng(lat,lng);
      getLocationsWithinRadiusOfLatLng(lat,lng,'load');
    });	
  }

  $("#submit").click(function(e){	
    e.preventDefault();	
    var loc = $("#location").val(),
        prevLoc = $("#location").attr('data-locations');

    if(loc != prevLoc) {
      $("#location").attr('data-locations',loc);	
      geocoder.geocode( { 'address' : loc }, function( results, status ) {
        if( status == google.maps.GeocoderStatus.OK ) {
          getLocationsWithinRadiusOfLatLng(results[0].geometry.location.lat(),results[0].geometry.location.lng(),'load');
          $("#position").val(results[0].geometry.location.lat() + "," + results[0].geometry.location.lng());
        } else {
          alert( 'Geocode was not successful for the following reason: ' + status );
        }							
      });			
    }
  });


  function getLocationsWithinRadiusOfLatLng(lat,lng,type) {

    var locationRange = GeoLocation.buildLocationRange(lat,lng,200),
        minLat = locationRange.minLat,
        maxLat = locationRange.maxLat,
        minLon = locationRange.minLon,
        maxLon = locationRange.maxLon;        

    var bookID = "1rFaW6QHDqqZKgLAq65oUiqdCT4DKG-FOY5MAO8cXUlc",  
        qry = encodeURIComponent("SELECT B, C, D, E, F, G, H, I, J, L, M WHERE B = TRUE AND L IS NOT NULL AND L <= " + maxLat + " AND L >= " + minLat + " AND M IS NOT NULL AND M <= " + maxLon + " AND M >= " + minLon),
        url = "https://docs.google.com/spreadsheets/d/" + bookID + "/gviz/tq?tqx=out:csv&tq=" + qry;    
    
    $.ajax({
      type: "GET",
      url: url,
      datatype: "json",
      success: function(data){
        var locJSON,
            locHTML = '',
            locs = '',
            count = 0,
            zoom = 9;

        data = Papa.parse(data,{header: true});

        if(data == '{}') {
          locJSON = [{ 
            lat: lat, 
            lng: lng, 
            zoom: 14
          }] 
        } else {
          locs = data.data;
          $(locs).each(function(index){   
            var loclat = this.Latitude,
                loclon = this.Longitude;
            this["Distance"] = getDistance(lat,lng,loclat,loclon).toFixed(2);
          });

          locs = locs.sort((a, b) => a.Distance - b.Distance);  
          locJSON = generateLocationJSON(locs,lat,lng);
          locHTML = generateLocationHTML(locs,lat,lng);

          $('.results').html(locHTML);
        }	

        if($(window).width() > 700) {
          if(type == 'load') {
            map.Load({
              locations: locJSON,
              map_options: {
                zoom: zoom,
                set_center: [lat,lng],
                pan_by: [getPanBy(zoom),0]
              }
            });
          }
          if(type == 'set') {
            map.SetLocations(locJSON,false)
          }
        }
      } 
    });
  }

  function loadCityStateFromLatLng(lat,lng) {
    var latlng = new google.maps.LatLng(lat,lng);

    geocoder.geocode({'latLng': latlng}, function(results, status) {
      if(status == google.maps.GeocoderStatus.OK) {
        if (results[1]) {
          var indice=0;
          for (var j=0; j<results.length; j++){
            if(results[j].types[0]=='locality'){
              indice=j;
              break;
            }
          }
          for(var i=0; i<results[indice].address_components.length; i++){
            if (results[indice].address_components[i].types[0] == "locality") {
              if(results[indice].address_components[i].long_name != undefined) {
                city = results[indice].address_components[i].long_name;	
              }
            }
            if (results[indice].address_components[i].types[0] == "administrative_area_level_1") {
              if(results[indice].address_components[i].short_name != undefined) {
                state = results[indice].address_components[i].short_name;   
              }
            }
            if(city != undefined && state != undefined){
              cityState = city+', '+state;
              $("#location").val(cityState);
              $("#position").val(lat + ',' + lng);
              $("#location").attr('data-last',cityState);
            }
          }
        } else {
          alert("No results found");
        }
      } else {
        alert("Geocoder failed due to: " + status);
      }
    });	
  }

  function generateLocationJSON(l,locLat,locLon) {
    var locJSON = '';
    $(l).each(function(index){
      if(index <= 10) {
        var name = this.Name,
            address = this.Address,
            city = this.City,
            state = this.State,
            zip = this.Zip,
            phone = this.Phone,
            website = this.Website,
            facebook = this.Facebook,
            lat = this.Latitude,
            lon = this.Longitude,
            distance = this.Distance;

        address += '<br>' + city;
        address += ', ' + state;
        address += ' ' + zip;

        var daddr = name + ' ' + address;
        daddr = daddr.replace(/<br>/g,' ');

        if(locJSON.length > 0 ){ locJSON += ',' }
        locJSON += '{ "lat" : ' + lat + 
          ', "lon" : ' + lon +
          ', "zoom" : 14, "title" : "' + name + '"' +
          ', "html" : "<div class=\\"result\\">' +
          '<h3>' + name + '</h3>' +
          '<div class=\\"detail\\">' + address;

        if(phone) { locJSON += '<br><a href=\\"tel:' + phone + '\\" class=\\"phone-link\\">Phone: ' + formatPhoneNumber(phone) + '</a>'; }
        locJSON += '<br><br>';
        locJSON += '<div class=\\"btn-row\\">';
        if(website) { locJSON += '<a href=\\"' + website + '\\" target=\\"_new\\" class=\\"btn-website\\">Shop Online</a>';  }
        locJSON += '<a class=\\"btn-directions\\" data-daddr=\\"' + daddr.replace(/"/g, '') + '\\">Shop In-Store</a>';
        locJSON += '</div>';

        locJSON += '</div>'
        locJSON += '</div>';
        locJSON += '", "icon" : "https://cdn.shopify.com/s/files/1/0023/0762/0931/files/black_marker_' + (index+1) + '.png?3705154472756887973"}'
      }
    });
    locJSON = '[' + locJSON + ']'
    locJSON = JSON.parse(locJSON);
    return locJSON;  
  }

  function generateLocationHTML(l,locLat,locLon) {
    var html = '';

    $(l).each(function(index){  
      if(index <= 10) {
        var name = this.Name,
            address = this.Address,
            city = this.City,
            state = this.State,
            zip = this.Zip,
            phone = this.Phone,
            website = this.Website,
            facebook = this.Facebook,
            lat = this.Latitude,
            lon = this.Longitude,
            distance = this.Distance;

        address += '<br>' + city;
        address += ', ' + state;
        address += ' ' + zip;    

        var daddr = name + ' ' + address;
        daddr = daddr.replace(/<br>/g,' ');

        html += '<div class="result">';
        html += '<div class="sequence">' + (index+1) + '</div>';
        html += '<div class="detail"><strong>' + name + '</strong><br>' + address;

        if(phone) { html += '<br><a href="tel:' + phone + '" class="phone-link">Phone: ' + formatPhoneNumber(phone) + '</a>'; }
        html += '<br><br>';
        html += '<div class="btn-row">';
        if(website) { html += '<a href="' + website + '" target="_new" class="btn-website">Shop Online</a>';  }
        html += '<a class="btn-directions" data-daddr="' + daddr.replace(/"/g, '') + '">Shop In-Store</a>';
        html += '</div>';

        html += '</div>';
        html += '</div>';
      }
    });
    return html;
  }	

  $(document).on('click', '.result', function(e){
    if(!$(e.target).hasClass('btn-directions') && !$(e.target).hasClass('btn-website')) {
      map.ViewOnMap($(".result").index(this) + 1);
    }
  });

  $(document).on('click', '.btn-directions', function(e){
    e.stopPropagation();
    var resultIndex = $(".result").index($(this).closest('.result'));
    map.ViewOnMap(resultIndex + 1);
    var daddr = $(this).attr('data-daddr');
    var saddr = document.getElementById("position").value;
    window.open('http://maps.google.com/maps?saddr=' + encodeURI(saddr) + '&daddr=' + encodeURI(daddr));
  });
  
  if($('.premiere').length) {
    var bookID = "1rFaW6QHDqqZKgLAq65oUiqdCT4DKG-FOY5MAO8cXUlc",  
        sheetID = "104994218",
        qry = encodeURIComponent("SELECT A, B, C, D WHERE A = TRUE ORDER BY B ASC"),
        url = "https://docs.google.com/spreadsheets/d/" + bookID + "/gviz/tq?tqx=out:csv&tq=" + qry + "&gid=" + sheetID;    

    $.ajax({
      type: "GET",
      url: url,
      datatype: "json",
      success: function(data){    

        data = Papa.parse(data,{header: true});  
        data = data.data;
        var html = '';
        
        $(data).each(function(){
          var logo = this.Logo.replace(".png", "_130x.png");
          html += '<li><a href="'+ this.Website +'"><img src="' + logo + '" title="' + this.Name + '" width="123" height="123"></a></li>';
        });
        $('.retailers').append(html);
      }
    });

    $('.premiere #view-all').on('click',function(){
      $('.retailers').css('height', 'auto');
      $('.premiere #view-all').hide();
    })
  }
  
});


function getDirections(daddr) {
  saddr = document.getElementById("position").value;
  window.open('http://maps.google.com/maps?saddr=' + encodeURI(saddr) + '&daddr=' + encodeURI(daddr))
}